import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import './Goals.scss';
import { urlFor, client } from '../../client';

const Goals = () => {
  const [goals, setGoals] = useState([]);

  useEffect(() => {
    const query = '*[_type == "goals"]';

    client.fetch(query).then((data) => {
      setGoals(data);
    });
  }, []);

  return (
    <>
      <h2 className="head-text"><span>&quot;</span>We know that<span> the ball doesn&apos;t score itself</span> <br />That&apos;s why <span>We have clear goals</span>&quot;</h2>

      <div className="app__goalss">
        {goals.map((goal, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 1, type: 'tween' }}
            className="app__goal-item"
            key={goal.title + index}
          >
            <img src={urlFor(goal.imgUrl)} alt={goal.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{goal.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{goal.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Goals, 'app__goals'),
  'our goals',
  'app__whitebg',
);
